import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  text-align: center;
  line-height: 2;
  padding: 0 20px;
`
